import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { MdOutlineCancel } from "react-icons/md";
import { ROLES } from "../../uitls/Utils";
import { FaPeopleGroup } from "react-icons/fa6";
import { IoPeople } from "react-icons/io5";
import { SiAwsorganizations } from "react-icons/si";
import { TbReportSearch } from "react-icons/tb";
import { RxDashboard, RxLayers } from "react-icons/rx";
import useAuth from "../../hooks/useAuth";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import PropTypes from "prop-types";
const SidebarLink = ({
  to,
  label,
  icon: Icon,
  activeButton,
  setActiveButton,
  buttonKey,
}) => (
  <NavLink
    to={to}
    onClick={() => setActiveButton(buttonKey)}
    className={`group relative flex items-center gap-3 rounded-xl py-3.5 pl-5 pr-5 font-semibold text-white duration-300 ease-in-out transition-all overflow-hidden ${
      activeButton === buttonKey
        ? "bg-gradient-to-r from-white/20 to-white/10 shadow-lg border-l-4 border-[#F5A623] transform scale-[1.02]"
        : "hover:bg-white/10 hover:shadow-md hover:transform hover:translate-x-1"
    }`}
  >
    {/* Animated background gradient */}
    <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/5 to-white/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 -translate-x-full group-hover:translate-x-full"></div>
    
    {/* Icon with animation */}
    <div className={`relative z-10 flex-shrink-0 transition-all duration-300 ${
      activeButton === buttonKey 
        ? "transform scale-110 text-[#F5A623]" 
        : "group-hover:scale-110 group-hover:text-[#F5A623]"
    }`}>
      {Icon && <Icon className="w-5 h-5" />}
    </div>
    
    {/* Label with animation */}
    <span className={`relative z-10 truncate transition-all duration-300 ${
      activeButton === buttonKey 
        ? "text-white font-bold" 
        : "group-hover:text-white"
    }`}>
      {label}
    </span>
    
    {/* Active indicator dot */}
    {activeButton === buttonKey && (
      <div className="absolute right-3 w-2 h-2 bg-[#F5A623] rounded-full animate-pulse"></div>
    )}
  </NavLink>
);

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const trigger = useRef(null);
  const sidebar = useRef(null);
  const { auth } = useAuth();
  const [activeButton, setActiveButton] = useState(
    localStorage.getItem("sidebarMenu") || ""
  );

  useEffect(() => {
    localStorage.setItem("sidebarMenu", activeButton);
  }, [activeButton]);

  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!sidebar.current || !trigger.current) return;
      if (
        !sidebarOpen ||
        sidebar.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setSidebarOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!sidebarOpen || keyCode !== 27) return;
      setSidebarOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });
  const userRole = localStorage.getItem("roleId") || null;
 const isSuperManager =auth.user.managerId == "" || auth.user.managerId == "N/A";
  const renderMenuItems = () => {
    if (userRole === ROLES.admin) {
      return (
        <ul>
          <li className="border-b-1">
            <SidebarLink
              to="/admin/dashboard"
              label="Dashboard"
              icon={RxDashboard}
              activeButton={activeButton}
              setActiveButton={setActiveButton}
              buttonKey="dashboard"
            />
          </li>
          <li>
            <SidebarLink
              to="/admin/employee"
              label="Employee"
              icon={FaPeopleGroup}
              activeButton={activeButton}
              setActiveButton={setActiveButton}
              buttonKey="employee"
            />
          </li>
          <li>
            <SidebarLink
              to="/admin/template"
              label="Template"
              icon={RxLayers}
              activeButton={activeButton}
              setActiveButton={setActiveButton}
              buttonKey="template"
            />
          </li>
          <li>
            <SidebarLink
              to="/admin/assign-template"
              label="Appraisal"
              icon={AssignmentOutlinedIcon}
              activeButton={activeButton}
              setActiveButton={setActiveButton}
              buttonKey="assign-template"
            />
          </li>
          <li>
            <SidebarLink
              to="/admin/business-unit"
              label="Business Unit"
              icon={SiAwsorganizations}
              activeButton={activeButton}
              setActiveButton={setActiveButton}
              buttonKey="business-unit"
            />
          </li>
          <li>
            <SidebarLink
              to="/admin/job-title"
              label="Job Title"
              icon={IoPeople}
              activeButton={activeButton}
              setActiveButton={setActiveButton}
              buttonKey="job-title"
            />
          </li>
        </ul>
      );
    }

    if (userRole === ROLES.mgr) {
      // Check if user is a child manager (has managerId)
     
      
      return (
        <ul>
          <li>
            <SidebarLink
              to="/mgr/dashboard"
              label="Dashboard"
              icon={RxDashboard}
              activeButton={activeButton}
              setActiveButton={setActiveButton}
              buttonKey="dashboard"
            />
          </li>
          <li>
            <SidebarLink
              to="/mgr/employee"
              label="Employee"
              icon={FaPeopleGroup}
              activeButton={activeButton}
              setActiveButton={setActiveButton}
              buttonKey="employee"
            />
          </li>
          <li>
            <SidebarLink
              to="/mgr/view-appraisal"
              label="Review Appraisal"
              icon={AssignmentOutlinedIcon}
              activeButton={activeButton}
              setActiveButton={setActiveButton}
              buttonKey="review-appraisal"
            />
          </li>
          {/* Show Self Appraisal menu only for child managers */}
      {!isSuperManager&&
            <li>
              <SidebarLink
                to="/mgr/self-appraisal"
                label="Self Appraisal"
                icon={TbReportSearch}
                activeButton={activeButton}
                setActiveButton={setActiveButton}
                buttonKey="self-appraisal"
              />
            </li>
       
      }
        </ul>
      );
    }

    if (userRole === ROLES.emp) {
      return (
        <ul>
          <li>
            <SidebarLink
              to="/emp/dashboard"
              label="Dashboard"
              icon={RxDashboard}
              activeButton={activeButton}
              setActiveButton={setActiveButton}
              buttonKey="dashboard"
            />
          </li>
          {/* <li>
            <SidebarLink
              to="/emp/view-appraisal?status=UnderFinalReview"
              label="View Appraisals"
              icon={TbReportSearch}
              activeButton={activeButton}
              setActiveButton={setActiveButton}
              buttonKey="view-appraisal"
            />
          </li> */}

           <li>
              <SidebarLink
                to="/emp/self-appraisal"
                label="Self Appraisal"
                icon={TbReportSearch}
                activeButton={activeButton}
                setActiveButton={setActiveButton}
                buttonKey="self-appraisal"
              />
            </li>
        </ul>
      );
    }

    

    return null;
  };

  return (
    <aside
      ref={sidebar}
      className={`absolute left-0 top-0 z-999 flex h-screen w-64 flex-col overflow-y-hidden shadow-2xl duration-300 ease-linear lg:static lg:translate-x-0 brand-sidebar relative ${
        sidebarOpen ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      {/* Decorative gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/5 via-transparent to-white/5 pointer-events-none"></div>
      
      <div className="relative z-10 flex items-center justify-between gap-2 px-6 py-6 border-b border-white/10">
        <NavLink
          to={`/${Object.keys(ROLES).find(
            (key) => ROLES[key] === userRole
          )}/dashboard`}
          className="flex items-center justify-center w-full group"
        >
          <div className="relative">
            <img
              src={"/images/ampPerformanceLogoNoBG.png"}
              alt="Logo"
              className="w-[180px] lg:align-middle mx-auto transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
          </div>
        </NavLink>
        <button
          ref={trigger}
          onClick={() => setSidebarOpen(!sidebarOpen)}
          aria-controls="sidebar"
          aria-expanded={sidebarOpen}
          className="block lg:hidden p-2 rounded-lg hover:bg-white/10 transition-all duration-200 hover:scale-110"
        >
          <MdOutlineCancel className="w-6 h-6 text-white" />
        </button>
      </div>

      <div className="relative z-10 no-scrollbar flex flex-col overflow-y-auto duration-300 ease-linear">
        <nav className="mt-0 py-0 lg:mt-6">
          <div>
            <ul className="mb-6 flex flex-col gap-2.5 px-4">
              {renderMenuItems()}
            </ul>
          </div>
        </nav>
        {/* <!-- Sidebar Menu --> */}
      </div>
    </aside>
  );
};
Sidebar.propTypes = {
  sidebarOpen: PropTypes.bool,
  setSidebarOpen: PropTypes.func,
};
SidebarLink.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  activeButton: PropTypes.string,
  setActiveButton: PropTypes.func.isRequired,
  buttonKey: PropTypes.string.isRequired,
};

export default Sidebar;
